import { register } from '@shopify/theme-sections';
import * as cart from '@shopify/theme-cart';
import ProductVariants from '../components/ProductVariants';

register('featured-product', {
  initFeatured: function () {
    const featuredProduct = this.container.querySelector(
      '[data-featured-product]',
    );
    this.featuredProductItem = new ProductVariants(featuredProduct);

    let currentItemId = featuredProduct.dataset.productId;
    let variantsList = featuredProduct.querySelector('[data-color-swatches]');
    let timespend = 0;
    if (variantsList != null) {
      let featuredProductWait = setInterval(() => {
        timespend = timespend + 2;
        if (this.featuredProductItem.allProductStyles != undefined) {
          let renderedBadge = this.featuredProductItem.buildBadge(
            this.featuredProductItem.badgeTags,
          );
          renderedBadge
            ? this.featuredProductItem.el
                .querySelector(`.${this.type}__image [data-product-link]`)
                .appendChild(renderedBadge)
            : null;
          clearInterval(featuredProductWait);
          for (const product in this.featuredProductItem.allProductStyles
            .products) {
            let swatchProduct =
              this.featuredProductItem.allProductStyles.products[product];
            let swatchItem =
              this.featuredProductItem.buildSwatchItem(swatchProduct);
            let currentItem = currentItemId == swatchProduct.id ? true : false;
            if (swatchItem) {
              if (currentItem) {
                swatchItem.classList.add('selected');
                variantsList.prepend(swatchItem);
                this.featuredProductItem.buildOtherSwatches(
                  swatchProduct,
                  this.type,
                  this.featuredProductItem.el.querySelector(
                    '.variants__size--list',
                  ),
                );
              } else {
                variantsList.appendChild(swatchItem);
              }
              swatchItem.addEventListener(
                'mouseenter',
                () => {
                  if (swatchItem.classList.contains('selected')) {
                    return false;
                  }
                  swatchItem.parentNode.parentNode.querySelector(
                    '[data-product-selected]',
                  ).textContent = swatchItem.dataset.colorName;
                },
                false,
              );
              swatchItem.addEventListener(
                'mouseleave',
                () => {
                  if (swatchItem.classList.contains('selected')) {
                    return false;
                  }
                  swatchItem.parentNode.parentNode.querySelector(
                    '[data-product-selected]',
                  ).textContent =
                    swatchItem.parentNode.parentNode.querySelector(
                      '.selected[data-product-swatch]',
                    ).dataset.colorName;
                },
                false,
              );
              swatchItem.addEventListener('click', (e) => {
                e.preventDefault();
                if (e.currentTarget.classList.contains('selected')) {
                  return false;
                }
                let itemTrack = {
                  Name: swatchProduct.title,
                  ProductID: swatchProduct.id,
                  Categories: swatchProduct.categories,
                  ImageURL: swatchProduct.featuredImage,
                  URL: 'https://reef-admin.myshopify.com' + swatchProduct.url,
                  Brand: swatchProduct.vendor,
                  Price: swatchProduct.formattedPrice,
                  CompareAtPrice: swatchProduct.formattedCompareAtPrice,
                };
                _learnq.push(['track', 'Viewed Product', itemTrack]);
                _learnq.push([
                  'trackViewedItem',
                  {
                    Title: itemTrack.Name,
                    ItemId: itemTrack.ProductID,
                    Categories: itemTrack.Categories,
                    ImageUrl: itemTrack.ImageURL,
                    Url: itemTrack.URL,
                    Metadata: {
                      Brand: itemTrack.Brand,
                      Price: itemTrack.Price,
                      CompareAtPrice: itemTrack.CompareAtPrice,
                    },
                  },
                ]);
                let addButton =
                  featuredProduct.querySelector('[data-product-add]');
                if (swatchProduct.selectedOrFirstAvailableVariant.available) {
                  addButton.setAttribute(
                    'data-selected-variant',
                    swatchProduct.selectedOrFirstAvailableVariant.id,
                  );
                  addButton.setAttribute('data-drawer-trigger', '');
                  addButton.textContent = 'Add to Cart';
                  addButton.classList.remove('out-of-stock');
                } else {
                  addButton.removeAttribute('data-selected-variant');
                  addButton.removeAttribute('data-drawer-trigger');
                  addButton.textContent = 'Out of Stock';
                }

                featuredProduct.querySelector(
                  '[data-product-selected]',
                ).textContent = swatchProduct.selectedColor;
                featuredProduct
                  .querySelector('[data-main-image]')
                  .setAttribute('src', swatchProduct.images[0]);
                featuredProduct
                  .querySelector('[data-main-image]')
                  .setAttribute(
                    'srcset',
                    this.featuredProductItem.buildSrcSet(
                      swatchProduct.images[0],
                    ),
                  );
                featuredProduct
                  .querySelector('[data-secondary-image]')
                  .setAttribute('src', swatchProduct.images[1]);
                featuredProduct
                  .querySelector('[data-secondary-image]')
                  .setAttribute(
                    'srcset',
                    this.featuredProductItem.buildSrcSet(
                      swatchProduct.images[1],
                    ),
                  );
                let renderedBadge = this.featuredProductItem.buildBadge(
                  swatchProduct.tags,
                );
                if (renderedBadge) {
                  this.featuredProductItem.el
                    .querySelector(
                      '.featured-product__image [data-product-link]',
                    )
                    .appendChild(renderedBadge);
                } else {
                  if (
                    this.featuredProductItem.el.querySelector(
                      '.badge__single',
                    ) != null
                  ) {
                    this.featuredProductItem.el
                      .querySelector('.badge__single')
                      .remove();
                  }
                }
                let links = featuredProduct.querySelectorAll(
                  '[data-product-link]',
                );
                links.forEach((link) => {
                  link.setAttribute('href', swatchProduct.url);
                });

                let titles = featuredProduct.querySelectorAll(
                  '[data-product-title]',
                );

                titles.forEach((title) => {
                  title.textContent = swatchProduct.title;
                });
                let priceSelectors = featuredProduct.querySelectorAll(
                  '[data-product-price]',
                );
                let priceSelectorsCompare = featuredProduct.querySelectorAll(
                  '[data-product-compare]',
                );
                priceSelectors.forEach((priceSelector) => {
                  priceSelector.textContent = swatchProduct.formattedPrice;
                  priceSelectorsCompare.forEach((priceSelectorCompare) => {
                    if (
                      swatchProduct.formattedCompareAtPrice &&
                      swatchProduct.formattedCompareAtPrice !=
                        swatchProduct.formattedPrice
                    ) {
                      priceSelector.classList.add('sale-price');
                      priceSelectorCompare.textContent =
                        swatchProduct.formattedCompareAtPrice;
                    } else {
                      priceSelector.classList.remove('sale-price');
                      priceSelectorCompare.textContent = '';
                    }
                  });
                });
                this.featuredProductItem.buildOtherSwatches(
                  swatchProduct,
                  this.type,
                  this.featuredProductItem.el.querySelector(
                    '.variants__size--list',
                  ),
                );
                variantsList
                  .querySelector('.selected[data-product-swatch]')
                  .classList.remove('selected');
                e.currentTarget.classList.add('selected');
              });
            }
          }
        } else {
          if (timespend > 10000) {
            clearInterval(featuredProductWait);
          }
        }
      }, 2);
    } else {
      this.featuredProductItem.buildOtherSwatches(
        this.featuredProductItem.data,
        this.type,
        this.featuredProductItem.el.querySelector('.variants__size--list'),
      );
    }
  },

  onLoad: function (e) {
    this.initFeatured();
  },
});
